/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrganizationDto
 */
export interface UpdateOrganizationDto {
    /**
     * Organization name
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    organizationName?: string;
    /**
     * Organization size
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    organizationSize?: UpdateOrganizationDtoOrganizationSizeEnum;
    /**
     * Organization commercial number
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    commercialNumber?: string;
    /**
     * Organization tax number
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    taxNumber?: string;
    /**
     * Organization business types
     * @type {Array<string>}
     * @memberof UpdateOrganizationDto
     */
    businessTypes?: Array<UpdateOrganizationDtoBusinessTypesEnum>;
}


/**
 * @export
 */
export const UpdateOrganizationDtoOrganizationSizeEnum = {
    SingleBranch: 'SINGLE_BRANCH',
    TwoToFiveBranches: 'TWO_TO_FIVE_BRANCHES',
    SixPlusBranches: 'SIX_PLUS_BRANCHES'
} as const;
export type UpdateOrganizationDtoOrganizationSizeEnum = typeof UpdateOrganizationDtoOrganizationSizeEnum[keyof typeof UpdateOrganizationDtoOrganizationSizeEnum];

/**
 * @export
 */
export const UpdateOrganizationDtoBusinessTypesEnum = {
    AutoElectrician: 'AUTO_ELECTRICIAN',
    AutoLos: 'AUTO_LOS',
    AutoMechanic: 'AUTO_MECHANIC',
    AutoServiceCenter: 'AUTO_SERVICE_CENTER',
    AutoTireStore: 'AUTO_TIRE_STORE',
    Reseller: 'RESELLER',
    AutoBatteryStore: 'AUTO_BATTERY_STORE',
    AutoBatteryTireStore: 'AUTO_BATTERY_TIRE_STORE',
    AutoServiceStation: 'AUTO_SERVICE_STATION',
    Wholesaler: 'WHOLESALER'
} as const;
export type UpdateOrganizationDtoBusinessTypesEnum = typeof UpdateOrganizationDtoBusinessTypesEnum[keyof typeof UpdateOrganizationDtoBusinessTypesEnum];


/**
 * Check if a given object implements the UpdateOrganizationDto interface.
 */
export function instanceOfUpdateOrganizationDto(value: object): value is UpdateOrganizationDto {
    return true;
}

export function UpdateOrganizationDtoFromJSON(json: any): UpdateOrganizationDto {
    return UpdateOrganizationDtoFromJSONTyped(json, false);
}

export function UpdateOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'organizationSize': json['organizationSize'] == null ? undefined : json['organizationSize'],
        'commercialNumber': json['commercialNumber'] == null ? undefined : json['commercialNumber'],
        'taxNumber': json['taxNumber'] == null ? undefined : json['taxNumber'],
        'businessTypes': json['businessTypes'] == null ? undefined : json['businessTypes'],
    };
}

export function UpdateOrganizationDtoToJSON(value?: UpdateOrganizationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationName': value['organizationName'],
        'organizationSize': value['organizationSize'],
        'commercialNumber': value['commercialNumber'],
        'taxNumber': value['taxNumber'],
        'businessTypes': value['businessTypes'],
    };
}

